export default "/images/phone-missed.svg?ca680c473b3d6fd82b279b8507d318e6";